module.exports = __webpack_public_path__ + "img/7-ilpakamanioMAS.26d7bcea.jpg";